import { render, staticRenderFns } from "./req-realtime-av-trans-modal.vue?vue&type=template&id=4e10ea8a"
import script from "./req-realtime-av-trans-modal.vue?vue&type=script&lang=js"
export * from "./req-realtime-av-trans-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports